import { useState, useEffect } from "react";
import axios from "axios";
import {
    Card,
    Grid,
    Box,
    Typography,
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
} from "@mui/material";
import MDAvatar from "components/MDAvatar";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import burceMars from "assets/images/dummy-logo.png";
import { DOMAIN } from "utils/api";
import { getVisiteRecords } from "utils/axios";
import { storeVisiterRecord } from "utils/axios";

export default function VisitPage() {
    const [option1, setOption1] = useState("");
    const [option2, setOption2] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [visiterName, setVisiterName] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [address, setAddress] = useState("");
    const [subject, setSubject] = useState("");
    const [visitors, setVisitors] = useState([]);
    const [selectedUserId, setSelectedUser] = useState();
    const [errors, setErrors] = useState({});

    console.log(visiterName, mobileNo, address, subject, 'visiterNamemobileNoaddresssubject')

    const [fromDate, setFromDate] = useState(new Date().toISOString().split("T")[0]); // Get current date in YYYY-MM-DD format
    const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]); // Get current date in YYYY-MM-DD format

    const handleFromDate = (e) => {
        setFromDate(e.target.value);
        console.log("From Date:", e.target.value);
    };

    const handleToDate = (e) => {
        setToDate(e.target.value);
        console.log("To Date:", e.target.value);
    };

    const handleJilhaChange = async (event) => {
        try {
            const selectedUserId = event.target.value;
            setSelectedUser(selectedUserId); // Update state if needed

            const token = localStorage.getItem("access_token");
            if (!token) throw new Error("No access token found");

            // Prepare the new visitor object
            const newVisitor = {
                user_id: selectedUserId,
                from_date: fromDate,
                to_date: toDate,
            };

            // Fetch updated visitor records
            const data = await getVisiteRecords(newVisitor);
            setVisitors(data);
        } catch (error) {
            console.error("Error fetching visitor records:", error);
        }
    };

    useEffect(() => {
        const fetchVisitors = async () => {
            const newVisitor = {
                user_id: selectedUserId,
                from_date: fromDate,
                to_date: toDate,
            };
            try {
                const data = await getVisiteRecords(newVisitor);
                setVisitors(data);
            } catch (error) {
                console.error("Error fetching visit records:", error);
            }
        };

        fetchVisitors();
    }, [selectedUserId, fromDate, toDate]);



    const validateForm = () => {
        let newErrors = {};
        if (!visiterName.trim()) newErrors.visiterName = "Name is required";
        if (!mobileNo.trim()) newErrors.mobileNo = "Mobile number is required";
        if (!address.trim()) newErrors.address = "Address is required";
        if (!subject.trim()) newErrors.subject = "Subject is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };

    const handleSubmit = async () => {
        if (!validateForm()) return; // Stop if validation fails

        try {
            const token = localStorage.getItem("access_token");
            if (!token) throw new Error("No access token found");

            const newVisitor = {
                visiter_name: visiterName,
                mobile_no: mobileNo,
                address: address,
                subject: subject,
            };

            await storeVisiterRecord(newVisitor); // ✅ Call function with fixed API request
            handleCloseDialog();
        } catch (error) {
            console.error("Error adding visitor:", error);
        }
    };


    const handleClickOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => {
        setOpenDialog(false);
        setErrors({});
        setVisiterName("");
        setMobileNo("");
        setAddress("");
        setSubject("");
    };
    const [accessData, setAccessData] = useState([]);

    useEffect(() => {
        // Get data from localStorage and parse it
        const storedData = localStorage.getItem("accessData");
        if (storedData) {
            setAccessData(JSON.parse(storedData)); // Assuming it's stored as a JSON string
        }
    }, []);
    // console.log(accessData, 'accessDataaccessData')

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const payload = { fromDate, toDate, option2 };
    //             console.log("Sending Payload:", payload);

    //             const res = await getVisiteRecords(fromDate, toDate, option2); // Pass dynamic values
    //             console.log(res, "API Response");
    //         } catch (error) {
    //             console.error("Error fetching visit records:", error);
    //         }
    //     };

    //     if (fromDate && toDate) {
    //         fetchData();
    //     }
    // }, [fromDate, toDate, option2]); // Runs when any of these values change


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box mt={5} mb={3}>
                <Card sx={{ p: 3 }}>
                    <Grid container spacing={3} mb={3} alignItems="center">
                        <Grid item>
                            <MDAvatar src={burceMars} alt="profile-image" size="xl" shadow="sm" />
                        </Grid>
                        <Grid item>
                            <MDTypography variant="h2" fontWeight="medium">
                                संपर्क
                            </MDTypography>
                        </Grid>
                    </Grid>

                    <Box sx={{ p: 2, backgroundColor: "#f8f9fa", borderRadius: "10px" }}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Select
                                        sx={{ height: "40px" }}
                                        value={option2} // Ensure this is properly initialized
                                        onChange={(e) => handleJilhaChange(e)}
                                        displayEmpty // Ensures the default text appears when no option is selected
                                    >
                                        {/* Default Placeholder Option */}
                                        <MenuItem value="" disabled>
                                            ----- Select Taluka -----
                                        </MenuItem>

                                        {/* Collector Option */}
                                        <MenuItem value="Collector">Collector</MenuItem>

                                        {/* Dynamic Options */}
                                        {accessData?.talukas?.length > 0 ? (
                                            accessData.talukas.map((item) => (
                                                <MenuItem key={item.taluka_id} value={item.taluka_id}>
                                                    {item.taluka_title}
                                                </MenuItem>
                                            ))
                                        ) : (
                                            <MenuItem disabled>No Options Available</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={4}>
                                <TextField
                                    type="date"
                                    label="From Date"
                                    fullWidth
                                    value={fromDate} // Set default value
                                    onChange={handleFromDate} // Update state on change
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    type="date"
                                    label="To Date"
                                    fullWidth
                                    value={toDate} // Set default value
                                    onChange={handleToDate} // Update state on change
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                        </Grid>
                    </Box>


                    <Box sx={{ textAlign: "right", mt: 2 }}>
                        <Button variant="contained" sx={{ backgroundColor: "#388e3c", color: "#fff", "&:hover": { backgroundColor: "#388e3c" } }} onClick={handleClickOpenDialog}>
                            Add Visitor
                        </Button>
                    </Box>
                </Card>
            </Box>

            <Box mt={3}>
                <Card sx={{ p: 3 }}>
                    <Typography variant="h4" gutterBottom>
                        Visitor Records
                    </Typography>
                    <Box sx={{ overflowX: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ddd" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#e0e0e0", textAlign: "left" }}>
                                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Name</th>
                                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Number</th>
                                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Address</th>
                                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Subject</th>
                                </tr>
                            </thead>
                            <tbody>
                                {visitors.length > 0 ? (
                                    visitors.map((visitor, index) => (
                                        <tr key={index} style={{ textAlign: "left" }}>
                                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{visitor.visiter_name}</td>
                                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{visitor.mobile_no}</td>
                                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{visitor.address}</td>
                                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{visitor.subject}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" style={{ textAlign: "center", padding: "10px", border: "1px solid #ddd" }}>No visitors found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </Box>
                </Card>
            </Box>

            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>Add Visitor</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} mt={1}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Name"
                                fullWidth
                                value={visiterName}
                                onChange={(e) => setVisiterName(e.target.value)}
                                error={!!errors.visiterName}
                                helperText={errors.visiterName}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Number"
                                fullWidth
                                value={mobileNo}
                                onChange={(e) => setMobileNo(e.target.value)}
                                error={!!errors.mobileNo}
                                helperText={errors.mobileNo}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Address"
                                fullWidth
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                error={!!errors.address}
                                helperText={errors.address}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Subject"
                                fullWidth
                                multiline
                                rows={4}
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                error={!!errors.subject}
                                helperText={errors.subject}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ backgroundColor: "#f44336", color: "#fff", "&:hover": { backgroundColor: "#f44336" } }}>Cancel</Button>
                    <Button onClick={handleSubmit} sx={{ backgroundColor: "#388e3c", color: "#fff", "&:hover": { backgroundColor: "#388e3c" } }}>Submit</Button>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}